import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {

  public reports: Array<any> = [];
  public pageSize = 15;
  public page = 1;
  public isClose = true;
  public hidePagination = false;
  public isNoneReports = false;

  public searchStr = '';
  public filteredData = [];

  constructor(
    private service: DataService,
    private router: Router,
    private translateService: TranslateService
  ) {
  }

  ngOnInit() {
    const project = JSON.parse(localStorage.getItem('project_id'));
    this.service.getReports(project.projectID.id)
      .pipe(
        map(r => r.map(it => {
          return {
            id: it.entityID.id2,
            projectId: it.entityID.id1.id,
            date: it.timeStamp,
            mode: it.genericAttributes.attributes.transportMode[0],
            category: it.genericAttributes.attributes.category ? it.genericAttributes.attributes.category[0] : "",
            status: it.genericAttributes.attributes.closure[0],
            source: it.genericAttributes.attributes.source_device[0],
            address: it.genericAttributes.attributes.address && it.genericAttributes.attributes.address.length > 0 && it.genericAttributes.attributes.address[0],
            description: it.genericAttributes.attributes.description[0]
          }
        }))
      )
      .subscribe(response => {
        this.reports = response;
        this.filteredData = this.reports;
        this.hidePagination = this.reports.length >= this.pageSize;
        this.isNoneReports = this.reports.length === 0;
      });

  }

  filterAddress(address, filterValue) {
    let filtered = false;
    for (const key in address) {
      const value = address[key] ? this.translateService.instant(address[key]) : "";
      filtered = value.toLowerCase().includes(filterValue.toLowerCase());
      if (filtered) break;
    }
    return filtered;
  }

  filter(event) {
    const filterValue = event.target.value;
    const that = this;
    this.filteredData = this.reports.filter(function (itm) {
      const mode = that.translateService.instant(itm.mode.toLowerCase()),
        description = that.translateService.instant(itm.description),
        source = that.translateService.instant((itm.source === 'WEBSITE' ? 'Web' : 'Smartphone').toLowerCase()),
        status = that.translateService.instant(itm.status.toLowerCase()),
        category = itm.category ? that.translateService.instant(itm.category.toLowerCase()) : "";

      return description.toLowerCase().includes(filterValue.toLowerCase()) ||
        itm.date.includes(filterValue.toLowerCase()) ||
        that.filterAddress(itm.address, filterValue) ||
        category.toLowerCase().includes(filterValue.toLowerCase());
    });
    this.isNoneReports = this.filteredData.length === 0;
  }

  public closeTutorial() {
    this.isClose = false;
  }

  public view(item) {
    this.router.navigate(['/reports', 'view', item.projectId, item.id]);
  }
}
